export function roundDecimal(number: number, rounded: number) {
  if (!number || !rounded) return null
  return (Math.round(number * 100) / 100).toFixed(rounded)
}
